/* Proof "Plain facts" (sections/pc-ln-proof-facts): the figures count up once, to exactly their values, when the
   row comes into view; the accounts figure takes the live count from snippet trader-count ([data-trader-count]).
   Reduced motion: final values at once. */
(function () {
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function init(root) {
    if (root.dataset.lpfaInit) return; root.dataset.lpfaInit = '1';
    var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var src = root.querySelector('[data-trader-count]'), out = root.querySelector('[data-lpfa-accounts]'), started = false, done = false;
    function fmt(n) { return Math.round(n).toLocaleString('en-US'); }
    function run(el, to, ms, suffix) {
      if (reduced) { el.textContent = fmt(to) + (suffix || ''); return; }
      var t0 = 0; (function step(now) { if (!t0) t0 = now; var t = Math.min(1, (now - t0) / ms); el.textContent = fmt(to * easeOut(t)) + (suffix || ''); if (t < 1) requestAnimationFrame(step); })(performance.now());
    }
    function accounts(force) {
      if (!src || !out || done) return;
      var txt = src.textContent || '', n = parseInt(txt.replace(/[^0-9]/g, ''), 10); if (isNaN(n)) return;
      if (/\+/.test(txt) && !force) return; /* still the fallback: wait briefly for the live figure */
      done = true; run(out, n, 1800, /\+/.test(txt) ? '+' : '');
    }
    if (src && 'MutationObserver' in window) new MutationObserver(function () { if (started) accounts(); }).observe(src, { childList: true, characterData: true, subtree: true });
    function go() {
      if (started) return; started = true;
      [].forEach.call(root.querySelectorAll('[data-lpfa-to]'), function (el) { run(el, +el.getAttribute('data-lpfa-to'), 1500); });
      accounts(); setTimeout(function () { accounts(true); }, 1600);
    }
    if (!('IntersectionObserver' in window) || reduced) { go(); return; }
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); go(); } }, { threshold: 0.5 });
    io.observe(root);
  }
  function boot() { document.querySelectorAll('[data-lpfa]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
